import './App.css';
import Loginform from './component/quizgame/loginform';
import AdminLogin from './component/admin/adminLogin';
import Question from './component/quizgame/question';
import RansomewareQuestion from './component/ransomwaremodule/ransomewareQuestion';
import SocialEngineeringQuestion from './component/socialengineeringmodule/socialEngineeringQuestion';
import PhishingModule from './component/phishingmodule/phishingModule';
import MalwareModule from "./component/malwaremodule/malwareModule";
import RansomwareModule from "./component/ransomwaremodule/ransomwareModule";
import SocialEngineeringModule from "./component/socialengineeringmodule/socialEngineeringModule";
// import DenailServiceModule from "./component/denialservice/denailserviceModule";
import MalwareQuestion from "./component/malwaremodule/malwareQuestion";
// import InsiderThreatQuestion from "./component/insiderthreat/insiderthreatQuestion";
// import InsiderThreatModule from "./component/insiderthreat/insiderthreatModule";
import Map from "./component/map/map";
import Toolkit from "../src/component/phishingmodule/toolkit";
import MalwareToolkit from "../src/component/malwaremodule/toolkit";
import RansomewareToolkit from "../src/component/ransomwaremodule/toolkit";
import SocialEngineeringToolkit from "../src/component/socialengineeringmodule/toolkit";
import InsiderToolkit from "../src/component/insiderthreat/toolkit";
// import DenialServiceToolkit from "../src/component/denialservice/toolkit";
// import DenialServiceQuestion from "../src/component/denialservice/denialserviceQuestion";
import CyberIsland from "../src/component/quizgame/cyberIsland";
import ProtectedRoute, { AdminProtected, UserProtected } from "./component/auth/ProtectedRoute";
import {
  BrowserRouter as Router, Routes, Route, Navigate,
} from "react-router-dom";
import SplashScreen from './component/quizgame/splashScreen';
import  Result  from './component/modulesresult/result';
import CompetitionScreen from './component/competitionscreen/competitionScreen';
import LeaderBoardScreen from './component/leaderboardscreen/leaderBoardScreen';

function App() {
  return (
    <>
       <Router>
        <Routes>
          <Route exact path="/" element={<Navigate to="/cyberIsland" replace />} />
          <Route exact path="/cyberIsland" element ={<SplashScreen/>}/>
          <Route path="/cyberisland/login" element={<Loginform />} />
          <Route path="/cyberisland/admin" element={<AdminLogin/>}/>

          {/* Admin Protected Routes - Require Admin Authentication */}
          <Route path="/cyberisland/competition" element={
            <AdminProtected>
              <CompetitionScreen/>
            </AdminProtected>
          }/>
          <Route path="/cyberisland/leaderboard" element={
            <AdminProtected>
              <LeaderBoardScreen/>
            </AdminProtected>
          }/>

          {/* User Protected Routes - Require User Authentication */}
          <Route path="/cyberisland/question/*" element={
            <UserProtected>
              <Question />
            </UserProtected>
          } />
          <Route path="/cyberisland/ransomewareQuestion/*" element={
            <UserProtected>
              <RansomewareQuestion/>
            </UserProtected>
          }/>
          <Route path="/cyberisland/malwareQuestion/*" element={
            <UserProtected>
              <MalwareQuestion/>
            </UserProtected>
          }/>
          <Route path="/cyberisland/socialengineeringQuestion/*" element={
            <UserProtected>
              <SocialEngineeringQuestion/>
            </UserProtected>
          }/>
          <Route path='/cyberisland/phishingmodule/*' element={
            <UserProtected>
              <PhishingModule/>
            </UserProtected>
          }/>
          <Route path='/cyberisland/socialengineeringmodule/*' element={
            <UserProtected>
              <SocialEngineeringModule/>
            </UserProtected>
          }/>
          <Route path="/cyberisland/phishingmap/*" element={
            <UserProtected>
              <Map/>
            </UserProtected>
          }/>
          <Route path='/cyberisland/ransomwaremodule/*' element={
            <UserProtected>
              <RansomwareModule/>
            </UserProtected>
          }/>
          <Route path='/cyberisland/malwaremodule/*' element={
            <UserProtected>
              <MalwareModule/>
            </UserProtected>
          }/>
          <Route path='/cyberisland/phishingtoolkit/*' element={
            <UserProtected>
              <Toolkit/>
            </UserProtected>
          }/>
          <Route path='/cyberisland/malwaretoolkit/*' element={
            <UserProtected>
              <MalwareToolkit/>
            </UserProtected>
          }/>
          <Route path='/cyberisland/ransomewaretoolkit/*' element={
            <UserProtected>
              <RansomewareToolkit/>
            </UserProtected>
          }/>
          <Route path='/cyberisland/socialengineeringtoolkit/*' element={
            <UserProtected>
              <SocialEngineeringToolkit/>
            </UserProtected>
          }/>
          <Route path='/cyberisland/insidertoolkit/*' element={
            <UserProtected>
              <InsiderToolkit/>
            </UserProtected>
          }/>
          <Route path='/cyberisland/instruction/*' element={
            <UserProtected>
              <CyberIsland/>
            </UserProtected>
          }/>
          <Route path='/cyberisland/result/*' element={
            <UserProtected>
              <Result/>
            </UserProtected>
          }/>
        </Routes>
      </Router>
    </>
  );
}

export default App;
